import styled from '@emotion/styled';

import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';
import DropdownV3 from '@zola/zola-ui/src/components/Form/dropdownV3';
import { Input } from '@zola/zola-ui/src/components/Form/dropdownV3/DropdownV3.styles';

const commonTextStyles = `
  font-size: ${FONT.SIZE.SMALLER};
  line-height: ${SPACING.MD};
  color: ${COLORS3.BLACK_100};
  font-family: ${FONT.FAMILY.SANS_SERIF};
  font-weight: ${FONT.WEIGHT.MEDIUM};
`;

const commonControlStyles = `
  ${commonTextStyles}
  background: ${COLORS3.BLACK_005};
  border-radius: 100px;
  border: 0;
  outline: 0;

  &:hover, &:active, &:focus {
    border: 0;
  }
`;

const commonContainerStyles = `
  align-items: center;
  display: flex;
  flex-flow: row;
`;

export const PLPControlsBarContainer = styled.div`
  ${commonContainerStyles}
  justify-content: space-between;
  max-width: 100%;
  width: 100%;

  & > div {
    width: 33.33%;

    ${MEDIA_QUERY.MOBILE} {
      width: 50%;
    }
  }
`;

export const ResultAndSort = styled.div`
  ${commonContainerStyles}
  justify-content: flex-end;
`;

export const ResultsTxt = styled.p`
  ${FONT.textSizeRegular(FONT.SIZE.SMALL)}
  color: ${COLORS3.BLACK_100};
  font-family: ${FONT.FAMILY.SANS_SERIF};
  font-weight: ${FONT.WEIGHT.REGULAR};
  margin: 0 ${SPACING.S16} 0 0;
`;

export const ChipContainer = styled.div`
  ${commonContainerStyles}
`;

export const ChipWrapper = styled.div<{ field?: string }>`
  margin-bottom: ${SPACING.XS};
  margin-right: ${SPACING.XS};

  &:last-of-type {
    margin-right: 0;
  }

  button {
    ${commonControlStyles};
  }
`;

export const StyledDropdown = styled(DropdownV3)`
  ${Input} {
    ${commonControlStyles};
    width: 185px;
  }
`;
